// Country code options for mobile dropdown (expand as needed)

/**
 * Returns the flag emoji for a given ISO 2-letter country code (e.g. 'IN' -> 🇮🇳)
 */
export function getFlagEmoji(countryCode: string): string {
  if (!countryCode) return "";
  // Convert to uppercase and ensure 2 chars
  const code = countryCode.toUpperCase();
  if (code.length !== 2) return "";
  // Unicode regional indicator symbols
  return String.fromCodePoint(
    ...[...code].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65)
  );
}

export interface DialCodeOption {
  value: string;
  label: string;
  countryCode: string;
}

export const dialCodeOptions: DialCodeOption[] = [
  { value: "+1", label: "+1 (USA/Canada)", countryCode: "US" },
  { value: "+91", label: "+91 (India)", countryCode: "IN" },
  { value: "+44", label: "+44 (UK)", countryCode: "GB" },
  { value: "+61", label: "+61 (Australia)", countryCode: "AU" },
  { value: "+81", label: "+81 (Japan)", countryCode: "JP" },
  { value: "+971", label: "+971 (UAE)", countryCode: "AE" },
  { value: "+65", label: "+65 (Singapore)", countryCode: "SG" },
  { value: "+49", label: "+49 (Germany)", countryCode: "DE" },
  { value: "+33", label: "+33 (France)", countryCode: "FR" },
  { value: "+86", label: "+86 (China)", countryCode: "CN" },
  // ...add more as needed
];
